import { render, staticRenderFns } from "./ZgbTeamMembersModify.vue?vue&type=template&id=7dd759ec"
import script from "./ZgbTeamMembersModify.vue?vue&type=script&lang=js"
export * from "./ZgbTeamMembersModify.vue?vue&type=script&lang=js"
import style0 from "./ZgbTeamMembersModify.vue?vue&type=style&index=0&id=7dd759ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports